import React from 'react'

import { OurOfficesType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'

import { Office } from './Office'
import { TitleSection } from './OurOffices.styled'

export const OurOffices = ({ officesTitle, subtitle, offices }: OurOfficesType): JSX.Element => {
    return (
        <TitleSection title={officesTitle} subtitle={subtitle}>
            <Grid container columnSpacing={6} rowSpacing={{ xs: 10, md: 20 }}>
                {offices.map((office) => (
                    <Grid item xs={12} md={6} key={office.address}>
                        <Office {...office} />
                    </Grid>
                ))}
            </Grid>
        </TitleSection>
    )
}
